import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"loading":!_vm.showIframePdf,"tile":"","elevation":"0"}},[_c(VCardText,[(_vm.showIframePdf)?_c('iframe',{staticClass:"iframe-custom",attrs:{"src":this.pdfPage,"frameborder":"0","scrolling":"no","allowfullscreen":""}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }